import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { map } from "rxjs/operators";
import { LorenUserLocationService } from "../../../../services/loren-user-location-service/loren-user-location.service";
import { LorenLocation } from "../../../../../features/loren-assets/interfaces/loren-location.interface";
import { LatLngLiteral } from "leaflet";

@Component({
  templateUrl: "./location-selection-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LocationSelectionDialogComponent {
  private locationService = inject(LorenUserLocationService);
  dialogRef = inject<MatDialogRef<LocationSelectionDialogComponent>>(MatDialogRef);
  data = inject<LatLngLiteral>(MAT_DIALOG_DATA);

  defaultLocation$ = this.locationService.getLocation().pipe(
    map((res) => {
      if (this.data && this.data.lat && this.data.lng) {
        return this.data;
      }

      return res;
    })
  );

  cancelClick() {
    this.dialogRef.close();
  }

  saveClick() {
    this.dialogRef.close(this.data);
  }

  handleDragEnd($event: LorenLocation) {
    this.data = { lat: $event.latitude, lng: $event.longitude };
  }

  handlePositionChange($event: LorenLocation) {
    this.data = { lat: $event.latitude, lng: $event.longitude };
  }
}
